import { UseStore } from '@eastcoal/common/types/zustand'
import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { MenutTreeStoreContext } from '../contexts/StoreContext'
import { ResourceBaseTreeStore } from '../store/interface'

export const useResourceBaseTreeStore: UseStore<
  ResourceBaseTreeStore
> = selector => {
  return useContextStore(MenutTreeStoreContext, selector)
}

export const useResourceBaseTreeStoreApi = () => {
  return useContextStoreApi(MenutTreeStoreContext)
}
